<nav class="navbar navbar-expand-md p-2 d-none">
    <div class="navbar-header h-100 mb-0 logo-bar text-center d-inline-block">
        <a class="horizontal-logo text-center">
            <img src="assets/imgs/logo01.png" />
        </a>
        <a class="close-nav-btn"><i class=" fa fa-times"></i></a>
    </div>
    <div class="text-center nav-btn-c align-middle d-inline-block">
        <button class="btn btn-green text-upper h-100">Volver al sitio web</button>
    </div>
  </nav>
  <div class="wrapper">

    <div class="sidebar">
        <div class="sidebar-header p1 align-self-center text-center">
            <a class="horizontal-logo text-center">
                <img src="assets/imgs/logo01.png" />
            </a>
        </div>
        <div class="site-width">
            <div class="btn-container text-center">
                <a href="https://sociedaddesegurosdevida.cr" class="btn btn-green text-upper h-100">Volver al sitio web</a>
            </div>
            <div class="icon-cont text-center mt-5">
                <i class="fa fa-facebook fa-4x me-4"></i>
                <i class="fa fa-instagram fa-4x"></i>
            </div>
        </div>
    </div>
  
    <div class="content">
      <!--PUBLIC VIEWs  -->
      <router-outlet></router-outlet>
    </div>
  
    <div class="containerBtn">
      <input type="checkbox" id="btn-mas">
      <div class="redes">
        <a href="https://www.callmyway.com/Welcome/ClickToCallSupport/e32a84f6848c01d42d00b7bde3a4bf3b" target="_blank" onclick="gtag('event', 'clickCallMyWay');" class="fa fa-phone"></a>
        <a href="https://webchat.sociedaddesegurosdevida.cr/ssvmn/webchat.php" target="_blank" onclick="gtag('event', 'clickContactChat');" class="fa fa-comments"></a>
      </div>
      <a class="btn-mas">
        <label for="btn-mas" onclick="gtag('event', 'customer-service');" class="customer-service">
          <img class="customer-serviceimg" src="../../assets/imgs/customer-service.png">
        </label>
      </a>
    </div>
    
  </div>
<ng-container #publicDialogContainerRef></ng-container>